module.exports = __webpack_public_path__ + "mh.svg?8fb2e631c1c0ce78a2b8f0f57cf8501f";